export default __webpack_public_path__ + "static/81494-45e261e48ba804dbb806165ee82639cd.jpg";